import SiteNav from '@/components/SiteNav'
import SiteFooter from '@/components/SiteFooter'

export default function SiteLayout({ children, navVariant, footerVariant }) {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SiteNav variant={navVariant} />
      <main className="flex-1">{children}</main>
      <SiteFooter variant={footerVariant} />
    </div>
  )
}
